import React from "react"
import { Button } from "@/components/ui/button"
import { Filter } from "lucide-react"
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet"

interface CatalogFiltersProps {
  children: React.ReactNode
  label: string
}

/**
 * Responsive wrapper for catalog filters.
 * Desktop: Shows as a sidebar.
 * Mobile: Shows as a drawer (Sheet).
 */
export const CatalogFilters = ({ children, label }: CatalogFiltersProps) => {
  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:block">{children}</div>

      {/* Mobile Trigger and Drawer */}
      <div className="flex-1 lg:hidden">
        <Sheet>
          <SheetTrigger asChild>
            <Button variant="outline" className="h-12 w-full gap-2 text-xs font-bold uppercase">
              <Filter className="h-4 w-4" />
              {label}
            </Button>
          </SheetTrigger>
          <SheetContent
            side="left"
            className="w-[300px] overflow-y-auto border-r-2 border-foreground/10 sm:w-[400px]"
          >
            <SheetHeader className="mb-8 border-b-2 border-foreground/5 pb-6 text-left">
              <SheetTitle className="font-display text-2xl tracking-widest">{label}</SheetTitle>
            </SheetHeader>
            {children}
          </SheetContent>
        </Sheet>
      </div>
    </>
  )
}

